// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3Q7Sj","col":"styles_col__3wH5e"};